import type { Client } from "../client";
import type { SigningKeyConfigurationResource } from "../resources";
import { ConfigurationRepository } from "./configurationRepository";
export class SigningKeyConfigurationRepository extends ConfigurationRepository<SigningKeyConfigurationResource> {
    constructor(client: Client) {
        super("SigningKeyConfiguration", client);
    }
    // overrides the base method in order to not use hypermedia links
    modify(resource: SigningKeyConfigurationResource): Promise<SigningKeyConfigurationResource> {
        return this.client.update<SigningKeyConfigurationResource>(this.client.getLink("SigningKeyConfiguration"), resource);
    }
}
